import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tools-circle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7.35963 13.0159C6.16579 11.8221 5.88434 10.0614 6.5153 8.60024L6.77999 8.65134L9.11344 10.9848L10.9863 9.11194L8.65284 6.77849L8.60161 6.51439C10.0626 5.8839 11.8229 6.16546 13.0165 7.35908C14.2035 8.54609 14.4885 10.2935 13.8715 11.7497L17.8115 15.6897L15.6902 17.811L11.7502 13.871C10.2941 14.488 8.54664 14.2029 7.35963 13.0159Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.35963 13.0159C6.16579 11.8221 5.88434 10.0614 6.5153 8.60024L6.77999 8.65134L9.11344 10.9848L10.9863 9.11194L8.65284 6.77849L8.60161 6.51439C10.0626 5.8839 11.8229 6.16546 13.0165 7.35908C14.2035 8.54609 14.4885 10.2935 13.8715 11.7497L17.8115 15.6897L15.6902 17.811L11.7502 13.871C10.2941 14.488 8.54664 14.2029 7.35963 13.0159Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ToolsCircle = Vue.extend<IconProps>({
  name: 'ToolsCircleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tools-circle',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ToolsCircle;
